/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["h1[_ngcontent-%COMP%]{color:#0080ff;font-size:1.3em;margin-bottom:.75rem}.owl-carousel[_ngcontent-%COMP%]{margin-bottom:1.25rem}.badge-new[_ngcontent-%COMP%]{color:#fff;background-color:#ff6000;font-size:65%;padding:.4rem .8rem .3rem}  .owl-w-100 .owl-stage,   .peek .owl-stage{padding-left:0!important}  .owl-stage{display:-webkit-box;display:flex}  .owl-item{padding:.25rem;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}  .owl-next,   .owl-prev{display:none;font-size:3rem;position:absolute;top:50%}  .owl-next i:before,   .owl-prev i:before{color:#0080ff}  .owl-next.disabled i:before,   .owl-prev.disabled i:before{color:gray}@media (min-width:768px){  .owl-next,   .owl-prev{display:block;font-size:1.25rem}  .owl-next{right:-2rem}  .owl-prev{left:-2rem}}@media (min-width:526px){  .owl-w-100 .owl-stage{padding-right:0!important}}"];
export { styles as styles };
//# sourceMappingURL=carousel.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/shared/carousel/carousel.component.scss.shim.ngstyle.js
// module id = 1455
// module chunks = 26 27 28